import { resolveSemanticColor } from '@/theme/semanticTokens';
import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

type ThemeSxFn = (
  theme: Theme,
) => Exclude<SxProps<Theme>, readonly unknown[] | ((theme: Theme) => unknown)>;

export const validationMappingValuesTitleSx: ThemeSxFn = (theme) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: theme.typography.subtitle1.lineHeight,
  fontWeight: theme.typography.subtitle1.fontWeight,
});

export const detectedMappingValuesTitleSx: ThemeSxFn = (theme) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: theme.typography.subtitle1.lineHeight,
  fontWeight: theme.typography.subtitle1.fontWeight,
});

export const validationMappingValuesListSx = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: s('xs'),
} as const;

export const validationMissingValueItemSx = {
  display: 'inline-flex',
} as const;

export const detectedMappingValueItemSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: s('xs'),
} as const;

export const detectedMappingValueIconSx: ThemeSxFn = (theme) => ({
  color: resolveSemanticColor(theme, 'success'),
  fontSize: 16,
});

export const buildDetectedMappingValueTextSx =
  (matched: boolean): ThemeSxFn =>
  (theme) => ({
    color: matched
      ? resolveSemanticColor(theme, 'success')
      : resolveSemanticColor(theme, 'textSecondary'),
    fontSize: theme.typography.subtitle1.fontSize,
    fontWeight: matched ? 600 : 400,
  });

export const validationMissingValueTextSx: ThemeSxFn = (theme) => ({
  color: resolveSemanticColor(theme, 'error'),
  fontSize: theme.typography.subtitle1.fontSize,
});

export const validationMappingValueSuffixSx: ThemeSxFn = (theme) => ({
  fontSize: theme.typography.subtitle1.fontSize,
});
